import script from "./CsgTerms.vue?vue&type=script&setup=true&lang=ts"
export * from "./CsgTerms.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__